import moment from 'moment';
import { parse, isValid, format } from 'date-fns';
import { toCalendarDate } from './calendarDate';

/**
 * Parse a stored date-only value into the local `Date` a picker must be given
 * to display that same calendar day.
 *
 * SW2-2244: kept as the spelling the findings paths already import, but the
 * conversion itself now lives in `toCalendarDate` so there is one
 * implementation instead of two. The offset arithmetic this replaced returned
 * the day at its UTC hour; the shared function returns the day at local
 * midnight. Every caller feeds a date picker, which reads only the calendar
 * parts, so the day is identical and the dropped time-of-day is not read.
 *
 * Unparseable input keeps the legacy `new Date()` result rather than becoming
 * `null`, so callers always get a `Date` as before.
 */
export const parseYMD = (ymdStr) => toCalendarDate(ymdStr) ?? new Date(ymdStr);

export const parseMDYformat = ymdStr => {
  const [year, month, day] = ymdStr.split('-').map(Number);
  const date = new Date(year, month - 1, day); // Month is zero-indexed

  const formattedDate = [
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
    date.getFullYear(),
  ].join('-');


  return formattedDate;

};

export const parseStringMDYformat = (ymdStr) => {
  const [year, month, day] = ymdStr.split('-');

  // Ensure month and day are always two digits
  const formattedDate = `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`;

  return formattedDate;
};

export const parseMDYformatWithoutUTC = ymdStr => {
  const [year, month, day] = ymdStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  const formattedDate = [
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
    date.getFullYear(),
  ].join('-');

  return formattedDate;
};

export function getDateOnly(input) {
  let date = null;

  if (typeof input === 'string') {
    const parsed = parse(input, 'MM-dd-yyyy', new Date());

    date = isValid(parsed) ? parsed : null;
  } else if (input instanceof Date || typeof input === 'number') {
    const parsed = new Date(input);

    date = isValid(parsed) ? parsed : null;
  } else {
    date = new Date();
  }

  return isValid(date) ? format(date, 'yyyy-MM-dd') : null;
}

export function getCurrentDateTime() {
  const now = new Date();

  return format(now, 'yyyy:MM:dd HH:mm:ss');
}

export function formatMMDDDateWithoutTimezone(dateString) {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-").map(Number);
  return format(new Date(year, month - 1, day), "MM/dd");
}



moment.fn.roundNext15Min = function () {
  let intervals = Math.floor(this.minutes() / 15);

  if (this.minutes() % 15 !== 0) {
    intervals++;
    if (intervals === 4) {
      this.add(1, "hours");
      intervals = 0;
    }
    this.minutes(intervals * 15);

    return this;
  }
};